import React from "react";
import Hero from "@/components/sections/Hero";
import AboutSection from "@/components/sections/AboutSection";
import ServicesGrid from "@/components/sections/ServicesGrid";
import Calculator from "@/components/sections/Calculator";
import Testimonials from "@/components/sections/Testimonials";
import Partners from "@/components/sections/Partners";
import FAQ from "@/components/sections/FAQ";
import CTASection from "@/components/sections/CTASection";

export default function Home() {
  return (
    <div data-testid="page-home">
      <Hero />
      <Partners />
      <AboutSection />
      <ServicesGrid limit={8} />
      <Calculator />
      <Testimonials />
      <FAQ />
      <CTASection />
    </div>
  );
}
